import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { HOME_PATH, useLandingResolver } from '../../access';

import useUserStore from '../../store/UserStore';
import useAuth from '../../utilities/useAuth';
import { useIsViewing } from '../../utilities/customHooks/useIsViewing';
import { analytics } from '../../modules/analytics';
import { useUnifiedDashboardStore } from '../../store/UnifiedDashboardStore';

import { isVatikaUser } from './header.rules';

export interface HeaderActions {
  isViewing: boolean;
  showVatikaLogo: boolean;
}

export const useHeaderActions = (): HeaderActions => {
  const { email } = useAuth();
  const { userId, userName } = useUserStore();
  const isViewing = useIsViewing();

  useEffect(() => {
    if (userId) {
      analytics.identifyUser({ distinctId: userId, userProperties: { email, name: userName } });
    }
  }, []);

  return { isViewing, showVatikaLogo: isVatikaUser(email) };
};

export const useGoToLanding = (): (() => void) => {
  const navigate = useNavigate();
  const landingNow = useLandingResolver();

  return () => {
    useUnifiedDashboardStore.getState().resetUnifiedDashboardStore();
    const landing = landingNow();
    navigate(landing.kind === 'open' ? landing.path : HOME_PATH);
  };
};
